import { LoaderFunctionArgs } from 'react-router';
import { getPropertyByID } from 'api/properties';
import { getPropertyViolations } from 'api/violations';
import { Property, PropertyViolation } from 'types';

export interface JobPropertyData {
  property: Property;
  violations: PropertyViolation[];
}

export interface JobsCreatePropertyLoaderData {
  _violations: Promise<PropertyViolation[]>;
}

// Resource route loader - fetches property details + violations
// Used by useFetcher.load() when user selects a property in tenant/group scope
export async function jobPropertyDataLoader({
  params,
}: LoaderFunctionArgs): Promise<JobPropertyData> {
  const propertyID = Number(params.propertyID);
  const tenantID = Number(params.tenantID);
  const [property, violations] = await Promise.all([
    getPropertyByID({ propertyID, tenantID }),
    getPropertyViolations({ propertyID, tenantID }),
  ]);
  return { property, violations };
}

// Loader for property-scope create route - violations only
// Property object is already available from outlet context
export function jobsCreatePropertyLoader({
  params,
}: LoaderFunctionArgs): JobsCreatePropertyLoaderData {
  const propertyID = Number(params.propertyID);
  const tenantID = Number(params.tenantID);
  return { _violations: getPropertyViolations({ propertyID, tenantID }) };
}
